// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__74w3V","modal":"Modal_modal__dd70q","slide-down":"Modal_slide-down__P5GlM"};